import Component from '@glimmer/component';
import { action } from '@ember/object';
import { next } from '@ember/runloop';
import { service } from '@ember/service';
import FundsService from 'donor-elf-web/services/funds-service';
import AddSomethingModal from 'donor-elf-web/services/add-something-modal';
import CampaignService from 'donor-elf-web/services/campaign-service';

export default class NavbarAddComponent extends Component {
  @service declare addSomethingModal: AddSomethingModal;
  @service declare campaignService: CampaignService;
  @service declare fundsService: FundsService;

  @action
  closeDropdown(dropdown: any) {
    next(() => {
      dropdown.actions.close();
    });
  }
}
